// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"ca178064","232":"5c2aa0f8","248":"1f55e76d","323":"30a53eee","340":"248e5587","799":"021f2f27"}[chunkId] + ".chunk.js";
};